import React from 'react';

function NotFoundPage() {
  return (
    <div>
      <h2>Erro 404 - Página não encontrada</h2>
      <p>A página que você está procurando não existe.</p>
    </div>
  );
}

export default NotFoundPage;
